import { Component } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'Home', url: '/home', icon: 'home' }
  ];

  constructor(public inAppBrowser: InAppBrowser) { }


  async socialMedia(type: any) {
    var here = this;
    switch (type) {
      case 'FACEBOOK': {
        here.inAppBrowser.create('https://m.facebook.com/profile.php?id=100068778008139&_rdr', '_system');
        break;
      }
      case 'INSTAGRAM': {
        here.inAppBrowser.create('https://www.instagram.com/misrinternationaluniversity', '_system');
        break;
      }
      case 'linkedin': {
        here.inAppBrowser.create('https://www.linkedin.com/school/misr-international-university', '_system');
        break;
      }
      case 'YOUTUBE': {
        here.inAppBrowser.create('https://www.youtube.com/channel/UCSWoceY_bLReeBUypucmheA', '_system');
        break;
      }

    }
  }

}
